import IAuthenticationService from "../../domain/services/IAuthentication.service";
import { fetchAuthentication, fetchProcessesValidate } from "./api/apiAuthentication";
import { IAccount } from "../interfaces/api/IAccount.inteface";

export default class Authentication implements IAuthenticationService {
  async getAuthOauthToken(): Promise<IAccount> {
    return await fetchAuthentication().then((r) => r.data);
  }
  async getProcessesValidate({ token, BearerToken }: { token: string, BearerToken: string }): Promise<IAccount> {
    return await fetchProcessesValidate(token, BearerToken).then((r) => r.data);
  }
}
